import React from 'react'
import { List } from './list'
import { FunctionSectionWrapper } from './styles'
const Video = React.lazy(() => import('./video'))

const Functioning: React.FC = () => {
  return (
    <FunctionSectionWrapper className="background">
      <div className=" mobile-tablet-video">
        <Video />
      </div>
      <div className="bp-mt-32">
        <div>
          <pichincha-typography
            class="bp-mt-24"
            variant="h3"
            color="blue"
            align="center"
          >
            ¿Cómo funciona?
          </pichincha-typography>
          <pichincha-typography variant="h5" align="center" class="bp-mt-16">
            Solicitar tu préstamo es así de fácil y rápido.
          </pichincha-typography>
        </div>
      </div>

      <div className="bp-mt-32 bp-pb-32 function-list-video">
        <div>
          <List />
        </div>
        <div className="desktop-video ">
          <Video />
        </div>
      </div>
    </FunctionSectionWrapper>
  )
}

export default Functioning
